import { RouteConfig } from 'vue-router';
// @ts-ignore
import Report from '@/views/PrimaryReport/Report.vue';

import { Permission } from '@/enums/Permission';
import { PermissionHelper } from "@/classes/PermissionHelper";

// @ts-ignore
import OrderSummary from "@/views/PrimaryReport/OrderSummary/index.vue";
// @ts-ignore
import DeliverySummary from "@/views/PrimaryReport/DeliverySummary/index.vue";

function redirectToUserAuthorizedRoute() {
    return "/primary-report/" + PermissionHelper([
        Permission.VIEW_PRIMARY_ORDER_SUMMARY_REPORT,
        Permission.VIEW_PRIMARY_DELIVERY_SUMMARY_REPORT,
    ], [
        
        { permission: Permission.VIEW_PRIMARY_ORDER_SUMMARY_REPORT, name: 'primary-order-summary' },
        { permission: Permission.VIEW_PRIMARY_DELIVERY_SUMMARY_REPORT, name: 'primary-delivery-summary' },
    ]);
}

const PrimaryReportRoutes: RouteConfig = {
    path: 'primary-report',
    name: 'primary-report',
    // @ts-ignore
    redirect: to => {
        return redirectToUserAuthorizedRoute();
    },
    components: {dashboard: Report},
    children: [

        {
            path: 'primary-order-summary',
            name: 'primary-order-summary',
            meta: {
                label: 'Order Summary',
                icon: 'ni ni-cart',
                permission: Permission.VIEW_PRIMARY_ORDER_SUMMARY_REPORT,
                breadCrumb: 'order-summary'
            },
            components: {report: OrderSummary}
        },
        {
            path: 'primary-delivery-summary',
            name: 'primary-delivery-summary',
            meta: {
                label: 'Delivery Summary',
                icon: 'ni ni-delivery-fast',
                permission: Permission.VIEW_PRIMARY_DELIVERY_SUMMARY_REPORT,
                breadCrumb: 'delivery-summary'
            },
            components: {report: DeliverySummary}
        },
    ]
};
export default PrimaryReportRoutes;
